"use client";

import React, { FC } from 'react';
import { ConfigurationStudio } from '@shesha-io/reactjs';

const Page: FC = () => {
    return (
        <ConfigurationStudio />
    );
};

export default Page;